import { dashboardConstants } from "./types";
import { beginLogout } from "../login/actions";
import { alertActions, loading } from "../alert/actions";
import {
  getDashboard,
  getAnnouncementDetail,
  isShowMemberApplication
} from "../../../services/dashboard.service";

const endError = error => {
  return dispatch => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: dashboardConstants.DASHBOARD_ERROR,
        error
      });
    }
  };
};

const getDashboardInfo = () => {
  return (dispatch) => {
    dispatch(request());
    return getDashboard().then(
      (response) => {
        dispatch(success(response.data));
        return response;
      },
      (error) => {
        dispatch(endError(error));
        return Promise.reject(error);
      }
    );
  };
  function request() {
    return {
      type: dashboardConstants.DASHBOARD_INFO_REQUEST,
      payload: {}
    };
  }
  function success(demands) {
    return {
      type: dashboardConstants.DASHBOARD_INFO_SUCCESS,
      payload: {
        info: demands,
        isCandidateCustomer: demands.isCandidateCustomer
      }
    };
  }
};

const getAnnouncementDetails = announcementId => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getAnnouncementDetail(announcementId).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: dashboardConstants.ANNOUNCEMENT_DETAIL_REQUEST,
      payload: {}
    };
  }
  function success(response) {
    return {
      type: dashboardConstants.ANNOUNCEMENT_DETAIL_SUCCESS,
      payload: { announcementDetail: response }
    };
  }
};

const setCandidateCustomerState = (isCandidateCustomer) => ({
  type: dashboardConstants.SET_CANDIDATE_CUSTOMER_STATE,
  payload: {
    isCandidateCustomer
  }
});

const isShowMemberApplications = () => {
  return async (dispatch) => {
    try {
      const res = await isShowMemberApplication();
      dispatch(endShowMemberApplication(res.data));
      return res;
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endShowMemberApplication = (data) => ({
  type: dashboardConstants.IS_SHOW_MEMBER_APPLICATION,
  payload: { isShowMemberApplication: data },
});

export { getDashboardInfo, getAnnouncementDetails, setCandidateCustomerState, isShowMemberApplications };
